import { useEffect, useState, useMemo } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import "./LanguageSelector.scss";
import { Stack, ThemeProvider, createTheme } from "@mui/material";
import { changeLanguage } from "i18next";
import { useTranslation } from "react-i18next";

const langSelTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          padding: "0",
        },
      },
    },
  },
});
const popoverMenu = createTheme({
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          boxShadow: "0px 3px 5px 0px rgba(55, 70, 73, 0.20)",
          padding: "0",
          marginTop: ".375rem",
          width: "7.5rem",
          background: "#fff",
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: "0",
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid #E6E7E8",
          padding: "0rem 1.5rem 0.5rem 1.5rem",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "transparent",
          },
        },
      },
    },
  },
});

export default function LanguageSelector() {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedLanguage, setSelectedLanguage] = useState<string>("");

  const menuItems: { id: string; label: string }[] = useMemo(
    () => [
      {
        id: "es",
        label: "Español",
      },
      {
        id: "en",
        label: "Inglés",
      },
      {
        id: "cat",
        label: "Catalán",
      },
      {
        id: "gal",
        label: "Gallego",
      },
      {
        id: "eus",
        label: "Euskera",
      },
    ],
    []
  );

  useEffect(() => {
    const lang =
      sessionStorage.getItem(process.env.REACT_APP_SESSIONSTORAGE_LANG!) ||
      "es";
    const language =
      menuItems.find(({ id }) => lang === id)?.label || "Español";
    setSelectedLanguage(language);
  }, [menuItems]);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (id: string, label: string) => {
    if (id.length) {
      changeLanguage(id);
      sessionStorage.setItem(process.env.REACT_APP_SESSIONSTORAGE_LANG!, id);
      setSelectedLanguage(label);
    }

    setAnchorEl(null);
  };

  return (
    <ThemeProvider theme={langSelTheme}>
      <>
        <Button
          disableRipple
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          style={{ alignSelf: "center" }}
          className="button"
        >
          <Stack
            direction="row"
            alignItems="center"
            className={anchorEl ? "ls-open" : "ls-box"}
            borderRadius="8px"
            padding="8px"
          >
            <div
              className="t-icon-globe brand-red ls-icon"
              style={{ fontSize: "20px", paddingRight: "8px" }}
            />
            <span className="brand-gray ls-text">{t(`Idiomas.${selectedLanguage}`)}</span>
            <div
              className={`${
                anchorEl ? "rotate-icon" : ""
              } brand-red t-icon-arrow-dropdown ls-icon`}
            />
          </Stack>
        </Button>
        <ThemeProvider theme={popoverMenu}>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            {menuItems.map(({ id, label }) => (
              <MenuItem
                key={id}
                onClick={() => handleClose(id, label)}
                style={{ fontFamily: "Nunito" }}
                sx={{
                  "&:hover": {
                    background: "transparent",
                  },
                }}
              >
                {t(`Idiomas.${label}`)}
              </MenuItem>
            ))}
          </Menu>
        </ThemeProvider>
      </>
    </ThemeProvider>
  );
}
